import { Banner, Button, Col, Row, Typography } from 'darrius';

import styles from './BannerDownloadApp.module.scss';

export const BannerDownloadApp = () => {
  return (
    <Banner className={`${styles['signup-mgm__download']} space-bottom full`}>
      <Row className="center-sm space-top space-bottom">
        <Col>
          <Typography.Title size="3xl">
            Consiga mais clientes agora mesmo!
          </Typography.Title>
          <Typography.Text className={styles.text}>
            Baixe o aplicativo e cadastre-se
          </Typography.Text>
          <Button.Link
            variation="primary"
            size="small"
            href="https://www.getninjas.com.br/download/app"
          >
            Baixar o aplicativo
          </Button.Link>
        </Col>
      </Row>
    </Banner>
  );
};
